module.exports = __webpack_public_path__ + "img/costa-rica.1e960611.png";